import { InviteMembersForm } from '@/components/companies/Form/InviteMembersForm/InviteMembersForm'
import { Dialog } from '@/components/ui/Dialog/Dialog'
import { profilesStore } from '@/store/profiles/profiles.store'
import { DialogTitle } from '@mui/material'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'src/components/modals/InviteMembersAppeal/InviteMembersAppeal.module.scss'
import InviteMembersImage from '@/assets/images/invite-members.png'
import { Close } from '@roolz/icons/Close'

interface Props {
  open: boolean
  setOpen: (open: boolean) => void
}

export const InviteMembersAppeal = ({
  open,
  setOpen
}: Props) => {
  const { t } = useTranslation('modals')
  const companyId = profilesStore.activeCompanyId
  const inviteText = t('invite_members_appeal.invite')
  const cancelText = t('invite_members_appeal.cancel')

  if (!companyId) {
    return null
  }

  const hideModal = () => {
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={hideModal}
      maxWidth='xs'
      classes={{ paper: styles.paper }}
      scroll='body'
    >
      <div className={styles.header}>
        <img
          className={styles.image}
          src={InviteMembersImage}
          alt=''
        />

        <CloseButton onClick={() => setOpen(false)}/>
      </div>

      <DialogTitle className={styles.title}>
        {t('invite_members_appeal.title')}
      </DialogTitle>

      <div className={styles.content}>
        <div className={styles.description}>
          {t('invite_members_appeal.description')}
        </div>

        <InviteMembersForm
          companyId={companyId}
          acceptText={inviteText}
          cancelText={cancelText}
          hideModal={hideModal}
        />
      </div>
    </Dialog>
  )
}


function CloseButton({
  onClick
}: {
  onClick: () => void
}) {
  return (
    <button
      className={styles.close}
      onClick={onClick}
    >
      <Close
        className={styles.close__icon}
        color='#8E8E93'
      />
    </button>
  )
}
